import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PolicyService } from './policy.service';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.css'],
  providers: [PolicyService]

})
export class PolicyComponent implements OnInit {

  print = 'Cargando..';
  @ViewChild('dataR') dataR: ElementRef;
  constructor(public policyService: PolicyService) { }

  ngOnInit() {
    this.policy();
  }

   policy() {
    this.policyService.policy().subscribe(resp => {
       this.dataR.nativeElement.innerHTML = resp.Description;
     });
 }

}


// WEBPACK FOOTER //
// ./src/app/policy/policy.component.ts